import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
    useTab,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_APRVAPP_DTL } from "@/tz/go/egaz/osci/lpco/app/service/OsciLpcoAprvService";
import {
    APIS as IQS_APIS,
    URLS as IQS_URLS,
    getIqsAccessData,
} from "@/tz/go/egaz/osci/ptl/mypg/iqs/services/OsciMypgIqsService";
import { APP_AMD_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_GEN";
import { APP_AMD_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_TRPT";
import { APP_AMD_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_INVC";
import { APP_AMD_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_ITM";
import { APP_AMD_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_AMD_DTL_ATCM";
import { APP_DTL_GEN } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_GEN";
import { APP_DTL_TRPT } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_TRPT";
import { APP_DTL_INVC } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_INVC";
import { APP_DTL_ITM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ITM";
import { APP_DTL_ATCM } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_ATCM";
import { APP_DTL_PAY_INFO } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_PAY_INFO";
import { APP_DTL_MSG } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_MSG";
import { APP_DTL_DCLR } from "@/tz/go/egaz/osci/lpco/comn/APP_DTL_DCLR";

export const OSCI0201016S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0006", "auth_osci0008", "auth_osci0015", "auth_osci0016", "auth_osci0018"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const { appId } = useParams();

    const location = useLocation();
    let param = { ...location.state };
    const menuTp = param?.menuTp || "APP";

    let tabSchemaList: any = [];

    const [amdRsnVisible, setAmdRsnVisibleVisible] = useState(false);
    const [cnclRsnVisible, setCnclRsnVisibleVisible] = useState(false);
    const [tansad, setTansadVisible] = useState(false);

    const [gnrl, setGnrlVisible] = useState(false);
    const [trpt, setTrptVisible] = useState(false);
    const [invc, setInvcVisible] = useState(false);
    const [itm, setItmVisible] = useState(false);
    const [atcm, setAtcmVisible] = useState(false);
    const [payInfo, setpayInfoVisible] = useState(false);
    const [msg, setMsgVisible] = useState(false);
    const [dclr, setDclrVisible] = useState(false);

    const [comnCdList, setComnCdList] = useState([]);

    const [bfAppParam, setBfAppParam] = useState<any>({});

    // Accessible IQS ID for IQS button !== IQS 버튼용 접근 가능 IQS ID ==!
    const [iqsId, setIqsId] = useState("");

    /*
     * Application Detail Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Application Ddtail Info Form !== 신청서 상세 정보 Form ==!
        mdfyAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
            defaultValues: {
                // ...(pgeStore?.form || {}),
            },
        }),
        bfAmdAppDtl: useForm({
            defaultSchema: SF_APRVAPP_DTL,
        }),
    };
    const appAprvNo = form.mdfyAppDtl.watch("appAprvNo");

    useEffect(() => {
        handler.setInit();
    }, []);

    useEffect(() => {
        if (comnCdList && comnCdList.length > 0) {
            handler.changeTab(0);
        }
    }, [comnCdList]);

    /*
     * Pre-Application Tab
     * !== 탭 정의 ==!
     */
    const tab = {
        tabSchema: useTab({
            defaultSchema: {
                id: "tab",
                schema: tabSchemaList,
            },
        }),
    };

    /*
     * Master Applidation Details Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Application Information !== 신청서 정보 조회 ==!.
        getAppInfo: useFetch({
            api: (appId) => APIS.getAppInfo({ appId: appId, orgCd: auth.get("orgCd") }),
            onSuccess: async (data) => {
                form.mdfyAppDtl.setValues({
                    ...data.appInfo.content,
                });
                location.state = { ...data.appInfo.content };

                if (data.appInfo.content!) {
                    if (data.appInfo.content.cstmOfceCd && data.appInfo.content.tansadYy && data.appInfo.content.tansadSrno) {
                        setTansadVisible(true);
                    }
                    if (data.appInfo.content.amdTpCd == "A") {
                        setAmdRsnVisibleVisible(true);
                    } else if (data.appInfo.content.amdTpCd == "C") {
                        setCnclRsnVisibleVisible(true);
                    }

                    // Check IQS only for applications not yet completed (AP/RJ/CL) !== 처리 완료(AP/RJ/CL) 전 신청서만 IQS 확인 ==!
                    if (
                        data.appInfo.content.appStatCd !== "AP" &&
                        data.appInfo.content.appStatCd !== "RJ" &&
                        data.appInfo.content.appStatCd !== "CL"
                    ) {
                        fetch.getIqsId.fetch(data.appInfo.content.appId);
                    }
                }

                // Load before-amendment info first so tab children get bfParam on mount
                // !== 자식 탭이 mount 시 bfParam을 받도록 정정 전 정보를 먼저 조회 ==!
                await fetch.getBeforeAppInfo.fetch({
                    ...data.appInfo.content,
                });

                handler.getTabSchemaList(data.appInfo.content);
            },
            onError: (error) => {},
        }),
        // Get Application Information(Before) !== 신청서 정보 조회(수정전) ==!.
        getBeforeAppInfo: useFetch({
            api: (data) => APIS.getBeforeAppInfo({ ...data }),
            onSuccess: (data) => {
                const bfContent = data?.appInfo?.content ?? {};
                form.bfAmdAppDtl.setValues({
                    ...bfContent,
                });
                // Trigger tab re-render with before app keys !== 정정 전 appId 전달을 위해 state 갱신 ==!
                setBfAppParam({ ...bfContent });
            },
            onError: (error) => {},
        }),
        // Get the accessible IQS ID !== 접근 가능한 IQS ID 조회 ==!
        getIqsId: useFetch({
            api: (appId) => IQS_APIS.getIqsIdByBsopId(appId, getIqsAccessData(auth)),
            onSuccess: (data) => {
                setIqsId(data?.iqsId?.content ?? "");
            },
            onError: (error) => {},
        }),
        getRprt: useFetch({
            api: () =>
                lpcoUtils.getRprtLpco(
                    param.appId,
                    ["AP", "CL"].indexOf(form.mdfyAppDtl.getValue("appStatCd")) > -1 ? "N" : "Y",
                ),
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
    };

    /*
     * Application Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        setInit: async () => {
            await handler.getAppInfo(appId);
            await render.tabView();
        },
        // Get Pre-Application Information !== 사전신청서 정보 조회 ==!
        getAppInfo: async (appId: any) => {
            fetch.getAppInfo.fetch(appId);
        },
        getTabSchemaList: async (data: any) => {
            const reqParam = { orgCd: data.orgCd, appCdNo: data.appCdNo, appTpCd: data.appTpCd };
            const comnCdList = await lpcoUtils.getCpntList(reqParam);
            comnCdList.map((item: any) => {
                if ("CON" != item.value) {
                    tabSchemaList.push({ label: item.label });
                }
            });
            tab.tabSchema.setSchema(tabSchemaList);
            setComnCdList(comnCdList);

            handler.changeTab(0);
        },
        // Hide existing tab contents when changing tab !== Tab변경 시 기존 탭 내용 숨김처리  ==!
        chanageTabVisible: () => {
            setGnrlVisible(false);
            setTrptVisible(false);
            setInvcVisible(false);
            setItmVisible(false);
            setAtcmVisible(false);
        },
        // Tab change event !== Tab변경 이벤트 ==!
        changeTab: async (index: any) => {
            handler.chanageTabVisible();
            let tabList = comnCdList;
            if (tabList && tabList.length > 0) {
                const tabInfo: any = tabList[index];
                switch (tabInfo.value) {
                    case "GEN":
                        setGnrlVisible(true);
                        break;
                    case "TRN":
                        setTrptVisible(true);
                        break;
                    case "INV":
                        setInvcVisible(true);
                        break;
                    case "ITM":
                        setItmVisible(true);
                        break;
                    case "ATC":
                        setAtcmVisible(true);
                        break;
                    case "PAY":
                        setpayInfoVisible(true);
                        break;
                    case "MSG":
                        setMsgVisible(true);
                        break;
                    case "DCL":
                        setDclrVisible(true);
                        break;
                }
            }
            tab.tabSchema.setActive(index);
        },
    };

    const render = {
        tabView: () => {
            const tabPanelList: any = [];
            const tabList = comnCdList;
            if (tabList != undefined) {
                tabList.map((item: any) => {
                    if ("GEN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {/* Cancellation has no before/after — show plain detail
                                    !== 취소는 정정 전/후가 없어 일반 상세로 표시 ==! */}
                                {gnrl &&
                                    (param.amdTpCd == "C" ? (
                                        <APP_DTL_GEN state={param} />
                                    ) : (
                                        <APP_AMD_DTL_GEN state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                    ))}
                            </Tab.Panel>,
                        );
                    } else if ("TRN" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {trpt &&
                                    (param.amdTpCd == "C" ? (
                                        <APP_DTL_TRPT state={param} />
                                    ) : (
                                        <APP_AMD_DTL_TRPT state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                    ))}
                            </Tab.Panel>,
                        );
                    } else if ("INV" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {invc &&
                                    (param.amdTpCd == "C" ? (
                                        <APP_DTL_INVC state={param} />
                                    ) : (
                                        <APP_AMD_DTL_INVC state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                    ))}
                            </Tab.Panel>,
                        );
                    } else if ("ITM" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {itm &&
                                    (param.amdTpCd == "C" ? (
                                        <APP_DTL_ITM state={param} />
                                    ) : (
                                        <APP_AMD_DTL_ITM state={param} form={form.bfAmdAppDtl} bfParam={bfAppParam} />
                                    ))}
                            </Tab.Panel>,
                        );
                    } else if ("ATC" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {atcm &&
                                    (param.amdTpCd == "C" ? (
                                        <APP_DTL_ATCM state={param} />
                                    ) : (
                                        <APP_AMD_DTL_ATCM state={param} form={form.bfAmdAppDtl} />
                                    ))}
                            </Tab.Panel>,
                        );
                    } else if ("PAY" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {payInfo && <APP_DTL_PAY_INFO state={param} form={form.bfAmdAppDtl} />}
                            </Tab.Panel>,
                        );
                    } else if ("MSG" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {msg && <APP_DTL_MSG state={param} form={form.bfAmdAppDtl} />}
                            </Tab.Panel>,
                        );
                    } else if ("DCL" == item.value) {
                        tabPanelList.push(
                            <Tab.Panel key={item.value}>
                                {dclr && <APP_DTL_DCLR state={param} form={form.bfAmdAppDtl} />}
                            </Tab.Panel>,
                        );
                    }
                });
            }
            return tabPanelList;
        },
    };

    return (
        <Page
        // id={pgeUid}
        // title={t(pgeTitle)}
        // navigation={{
        //     base: lpcoEnvs.base,
        //     nodes: [...BASE.nodes, { path: "/E", label: "L_CO_LCNE" }, { path: "/E", label: pgeTitle }], // !== TODO path 추가구현 필요 ==!
        // }}
        >
            {" "}
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appNo} />
                            <Group.Control {...form.mdfyAppDtl.schema.ucrNo} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appNm} />
                            <Group.Control {...form.mdfyAppDtl.schema.appTpNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.sbmtDtm} />
                            <Group.Control {...form.mdfyAppDtl.schema.aprvDtm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.mdfyAppDtl.schema.appStatNm} />
                            <Group.Control {...form.mdfyAppDtl.schema.appXpirDt} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Label {...form.mdfyAppDtl.schema.tansadNo} />
                            {tansad && (
                                <>
                                    <Group.Field
                                        as="link"
                                        onClick={() => {
                                            modal.openModal({
                                                url: `${
                                                    lpcoEnvs.base
                                                }/lpco/tansad/osci0202002q/${form.mdfyAppDtl.getValue(
                                                    "cstmOfceCd",
                                                )}-${form.mdfyAppDtl.getValue("tansadYy")}-${form.mdfyAppDtl.getValue(
                                                    "tansadSrno",
                                                )}`,
                                                draggable: true,
                                                callback: (data) => {
                                                    modal.closeModal();
                                                },
                                            });
                                        }}
                                    >
                                        <Group.Control {...form.mdfyAppDtl.schema.cstmOfceCd} />
                                        <Group.Any>-</Group.Any>
                                        <Group.Control {...form.mdfyAppDtl.schema.tansadYy} />
                                        <Group.Any>-</Group.Any>
                                        <Group.Control {...form.mdfyAppDtl.schema.tansadSrno} />
                                    </Group.Field>
                                </>
                            )}
                            {!tansad && <Group.Field />}
                        </Group.Row>

                        {appAprvNo && (
                            <Group.Row>
                                <Group.Control {...form.mdfyAppDtl.schema.appAprvNo} controlSize={10} />
                            </Group.Row>
                        )}
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.osci0201015q);
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            {/* <Button
                                variant="secondary"
                                onClick={() => {
                                    fetch.getRprt.fetch();
                                }}
                            >
                                {" "}
                                {t("B_PRNT")}
                            </Button> */}
                            {iqsId && (
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        modal.openModal({
                                            url: `${IQS_URLS.osci0102003s}/${iqsId}`,
                                            size: "md",
                                            draggable: true,
                                            callback: (data) => {
                                                modal.closeModal();
                                            },
                                        });
                                    }}
                                >
                                    {t("B_IQS")}
                                </Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Layout direction="col">
                        {amdRsnVisible && (
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"L_AMD_RSN_1"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>
                        )}
                        {cnclRsnVisible && (
                            <Layout>
                                <Layout.Left>
                                    <Group.Title title={"L_CNCL_RSN_1"} titleSize={1}></Group.Title>
                                </Layout.Left>
                            </Layout>
                        )}

                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.mdfyAppDtl.schema.amdRsn} controlSize={12} />
                            </Group.Row>
                        </Group.Section>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Tab
                        {...tab.tabSchema.tab}
                        onChange={(index) => {
                            // 탭이 변경되었을때 index 번호와 onChange 이벤트를 호출
                            handler.changeTab(index);
                        }}
                    >
                        {render.tabView()}
                    </Tab>
                </Group.Body>
            </Group>
        </Page>
    );
};
